export enum ConsumerProfilePostSubmissionConfigRulesVariant {
  Default = 'default',
  Offer = 'offer'
}